import buildRaceQualifying from './panels/buildRaceQualifying'
import buildRaceQualifying2 from './panels/buildRaceQualifying2'
import buildRaceSemifinal from './panels/buildRaceSemifinal'
import buildRaceFinal from './panels/buildRaceFinal'

export default (raceInfoData, pageData) => {

  const r = {}
  r.data = {
    race: raceInfoData,
    page: pageData
  }
  const init = () => {
    console.log('buildRacePanels', r.data);

    functions[r.data.page.tournament](r.data);
  }

  const functions = {
    qualifying: buildRaceQualifying,
    qualifying2: buildRaceQualifying2,
    semifinal: buildRaceSemifinal,
    final: buildRaceFinal
  }

  init();
}
